import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ClienteRutas from "./cliente/rutas/ClienteRutas";
import AdminRutas from "./admin/rutas/AdminRutas";
import Reservar from './cliente/paginas/Reservar';
import './index.css';
import Confirmacion from './cliente/paginas/Confirmacion'; 
import MisViajes from './cliente/paginas/MisViajes';
import VerTicket from './cliente/paginas/VerTicket';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminRutas />} />
        <Route path="/reservar" element={<Reservar />} />
        <Route path="/confirmacion" element={<Confirmacion />} />
        <Route path="/mis-viajes" element={<MisViajes />} />
        <Route path="/boleto/:id" element={<VerTicket />} />
        <Route path="/*" element={<ClienteRutas />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
